import s from './Card.module.css';

export default function Card({
  variant = 'default',
  frame = null,
  padding = 'md',
  as: Tag = 'div',
  children,
  className = '',
  ...rest
}) {
  const cls = [
    s.card,
    variant === 'elevated' ? s.elevated : '',
    frame === 'gold' ? s.frameGold : '',
    s[`padding-${padding}`],
  ].filter(Boolean).join(' ');
  return (
    <Tag className={`${cls} ${className}`.trim()} {...rest}>
      {children}
    </Tag>
  );
}
